import { trim , mergeJson , getCurrHost } from "./utils";
import CONSTS_CONFIG from "../baseConfig/consts";
import { getApiUserInfo , reportEventAction } from "../server/api";
var iOSWindow = window.flutter_inappwebview
/**
 * 获取android 的bridge
 * @returns 
 */
function getAndroidBridge(){ return window.bangbetInterface; }

/**
 * 通过bridge 获得参数
 * @param {*} androidBrige 
 * @returns 
 */
function getAppParams(androidBrige){
    var rlt = {};    
    if (androidBrige.getComprehensiveQuickPaymentInfo) {
        var data = androidBrige.getComprehensiveQuickPaymentInfo();
        var country = androidBrige.getCountry()
        if (data && data.indexOf("{") != -1) {
            data = JSON.parse(data);
            data.platfrom && (rlt.platfrom = data.platfrom);
            country && (rlt.country = country);
            data.secret && (rlt.secretKey = data.secret);
            data.token && (rlt.token = data.token);
            // data.amount && (rlt.amount = data.amount);
        }
    }
    return rlt;
}

/**
 * 上报给父节点
 * @param {*} self 
 * @param {*} params 
 */
export function reportToParent(self , params){
    let bridge = getAndroidBridge();
    var uris = self.$store.getters['getUriParams'];
    var orig = uris.orig;
    if (window.isBangbetCasinoDomain) { 
        orig && (orig = decodeURIComponent(orig));
        !orig && (orig = getCurrHost());
        setTimeout(() => {
            window.parent.postMessage(params , orig);
        }, 150);
        return
    }
    if (!bridge) { 
        orig && (orig = decodeURIComponent(orig));
        !orig && (orig = getCurrHost());
        setTimeout(() => {
            window.parent.postMessage(params , orig);
        }, 150);
    } else {
        if (params.cmd == CONSTS_CONFIG.PARENT_CMD.SUCCESS) {
            if (!uris.amount) {
                return;
            }
            !params.data && (params.data = {});
            params.data.amount = uris.amount;
            if (bridge.setComprehensiveQuickPaymentResult) {
                bridge.setComprehensiveQuickPaymentResult(params);
            }
        } else if (params.cmd == CONSTS_CONFIG.PARENT_CMD.CANCEL) { 
            // alert(bridge.closeUI);
            if (bridge.closeUi) {
                setTimeout(() => {
                    bridge.closeUi();
                }, 150);
            }
        } else if (params.cmd == CONSTS_CONFIG.PARENT_CMD.LIVECHAT) {
            bridge.showAIHelp && bridge.showAIHelp();
        } else if (params.cmd == CONSTS_CONFIG.PARENT_CMD.WHATSAPP) {
            bridge.showWhatsApp && bridge.showWhatsApp();
        } else if (params.cmd == "paystack") {
            orig && (orig = decodeURIComponent(orig));
            !orig && (orig = getCurrHost());            
            setTimeout(() => {
                window.parent.postMessage(params , orig);
            }, 150);            
        }
        
    }
}

/**
 * 支付成功
 * @param {*} self 
 */
export function paySuccess(self){
    var params = {cmd:CONSTS_CONFIG.PARENT_CMD.SUCCESS}
    reportToParent(self , params);
}

export function toLiveChat(self){
    var params = {cmd:CONSTS_CONFIG.PARENT_CMD.LIVECHAT}
    if(window.bangbetInterface && window.bangbetInterface.showAIHelp){
        window.bangbetInterface.showAIHelp()
    } else { 
        reportToParent(self , params);  
    }
}

export function removePreload(self){
    var params = {cmd:CONSTS_CONFIG.PARENT_CMD.PRELOAD}
    reportToParent(self , params);    
}

export function whatsappNum(){
    let nums = JSON.parse(window.localStorage.getItem('license.config')).contactInformation
    if(nums){
        let phoneNum = ''
        nums.forEach(element => {
            if(element.type == 3){
            phoneNum = element.information[0].value
            }
        });
        return phoneNum
    } else {
        return ''
    }

}

/* whatsapp跳转 */
export function jumpWhatsApp() {   
    let url = '' 
    if (window.bangbetInterface && window.bangbetInterface.showWhatsApp) { 
        window.bangbetInterface.showWhatsApp();
    } else if(iOSWindow && iOSWindow.callHandler){
        url = `https://wa.me/${whatsappNum()}`;
        openStartUrl(url)
    } else {
        url = `https://wa.me/${whatsappNum()}`;
        window.open(url , '_blank');
    }
}

export function openStartUrl(url) {
    if (!iOSWindow || !iOSWindow.callHandler) return false;
    let dataNow = {
      type: "openStartUrl",
      url: url,
    };
    let dataNew = JSON.stringify(dataNow);
    return iOSWindow.callHandler("BangbetBridge", [dataNew]);
  }

/**
 * 关闭弹窗
 * @param {*} self 
 */
export function closePop(self) {
    var params = {cmd:CONSTS_CONFIG.PARENT_CMD.CANCEL}
    reportToParent(self , params);   
}

function parseParams(query , rlt){
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var pairKey = trim(pair[0]);
        if (pair.length >= 2) {
            if (['userToken', 'secretKey'].indexOf(pairKey) !== -1) {
                if (!pair[1] || pair[1] == "null" || trim(pair[1]) == "") continue;
                try {
                    rlt[pairKey] = decodeURIComponent(trim(pair[1]));
                } catch (e) {
                    rlt[pairKey] = trim(pair[1]);
                }
            } else {
                rlt[pairKey] = trim(pair[1]);
            }
        } else {
            !rlt.cn && (rlt.cn = pairKey);
        }
    }
    return rlt;
}

function parseUrl(){
    var hrefArr = window.location.href.split("?");
    var query = hrefArr.length > 1 ? hrefArr[hrefArr.length - 1] : "";
    var rlt = {};
    parseParams(query , rlt);
    if (window.top.localStorage) {
        let temp = window.top.localStorage.getItem("toBangPayUri");
        if (temp && temp.indexOf("&") != -1) {
            query = temp;
            parseParams(query , rlt);
        }
    }
    return rlt;
}

/**
 * 初始化用户信息
 * @param {*} self 
 */
export function initHook(self , callback){
    let params = parseUrl();
    let bridge = getAndroidBridge();
    if (bridge) {
        if (window.self !== window.top) {
            
        }  else {
             delete params.type
        }
       
        params = mergeJson(params , getAppParams(bridge) , true);
        if (!params.type) {
            params.type = 'deposit'
        }
    }
    self.$store.commit("setParams" , params);
    var loginData = {
        platform:3,
        isLogin: true
    }
    params.platform && (loginData.platform = params.platform);
    if (!params.country) {
        let cUser = self.$store.getters['userInfo'];
        cUser.country && (params.country = cUser.country);
    }
    // 获取userInfo 信息 , 预加载测试不访问API接口
    if (!params.isPreTesting) {
        setTimeout(() => {
            getApiUserInfo(loginData).then(res => {
                if (res.result == 1) {
                    self.$store.commit("setUser" , res.data);
                    callback(res.data.country);
                } else {
                    callback(false);
                }
            }).catch(err => {
                callback(false);
            });        
        }, 50);
    }
    return params;
}

export function toThirdParterWeb(url){
    var ifr = document.getElementById("bangPayThirdParterCon");
    if (ifr) {
        ifr.parentNode.removeChild(ifr);
    }
    var handler = setTimeout(() => {
        handler && clearTimeout(handler);
        var div = document.createElement('div');
        div.id = "bangPayThirdParterCon";
        var wd = "100%";
        var hd = "100%";
        div.innerHTML = '<iframe id="bangPayThirdParter" name="bangPayThirdParter" webkitallowfullscreen="true" allowtransparency="true" mozallowfullscreen allowfullscreen width="' + wd + '" height="' + hd + '" frameborder="0" style="margin: 0 auto;" src="' + url + '">';
        div.style = 'position: fixed;top: 0;right: 0;bottom: 0;left: 0;background-color: #fff;justify-content: center;align-items: center;z-index: 100000; display:none;';
        if (document.body){
            document.body.appendChild(div);
        }
        handler = setTimeout(() => {
            handler && clearTimeout(handler);
            var ifr = document.getElementById("bangPayThirdParterCon");
            if (ifr) ifr.style.display = "block";
        }, 500);
    }, 150);
}

/**
 * 创建动态SCRIPT
 * @param {*} url 
 * @param {*} isAsync 
 * @param {*} callback 
 */
 function createScript(url , isAsync , callback){
    let isLoaded = false;
    let nds = document.getElementsByTagName("script");
    !nds && (nds = []);
    for (let i = 0 ; i < nds.length ; i++) {
        if (nds[i]['src'] == url) {
            isLoaded = true;
            break;
        }
    }
    if (isLoaded) {
        callback && callback();
    } else {
        var script = document.createElement("script");
        script.async = isAsync;
        script.src =  url;
        script.charset = 'UTF-8';
        script.setAttribute('crossorigin', '*');
        //载入完成的回调函数
        callback && (script.onload = callback);
    
        
        if (nds && nds[0]) {
            nds[0].parentNode.insertBefore(script, nds[0]); 
        } else {
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    }
}

export function preloadGameRes(){
    var _doc = document.getElementsByTagName('script');
    var isLoaded = false;
    if (_doc && _doc.length > 0) {
        for(var i = 0 ; i < _doc.length ; i++) {
            _doc[i].src && (_doc[i].src.indexOf("cocos2d-js-min.js") != -1) && (isLoaded = true);
        }    
    }
    if (!isLoaded) {
        let baseUri = window.location.protocol + "//" + window.location.host;
        if (baseUri.indexOf("localhost") != -1) {
            return;
        }
        baseUri += "/casino/game/libs";
        createScript(baseUri + "/cocos2d-js-min.js", true , null);  
    }
}

function getUUid(){
    let udid = null;
    window.localStorage && (udid = window.localStorage.getItem("unique-udid"));
    if (!udid) {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        udid = (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
        window.localStorage && window.localStorage.setItem("unique-udid" , udid);
    }
    return udid;
}

function getFingerId(){
    let id = null;
    window.localStorage && (id = window.localStorage.getItem("fingerPrint"));
    !id && (id = "0");
    return id;
}

export function loadFingerPrint(){
    if (window.localStorage) {
        let fingerPrint = window.localStorage.getItem("fingerPrint");
        if (!fingerPrint) {
            function initFingerprintJS(){
                FingerprintJS.load().then(fp => {
                    fp.get().then(result => {
                        if (result.visitorId) {
                            window.localStorage.setItem("fingerPrint" , result.visitorId);
                        } else {
                            window.localStorage.setItem("fingerPrint" , getUUid());
                        }                   
                    });
                });       
            }
            // 开始加载
            let baseUri = window.location.protocol + "//" + window.location.host;
            createScript(baseUri + "/static/fp.min.js?v=1.1" , true , initFingerprintJS);            
        }
    }
}

export function reportEvent(self , params){
    if (!params) {
        return;
    }
    if (!self || !self.$store || !self.$store.state) {
        return;
    }
    var uri = window.location.protocol + "//" + window.location.host;
    if (window.location.pathname != "/") uri += "/" + window.location.pathname;    
    var ua = ""; 
    if (window.top && window.top.window) {
        var win = window.top.window;
        win.navigator && win.navigator.userAgent && (ua = win.navigator.userAgent);

        uri = win.location.protocol + "//" + win.location.host;
        if (win.location.pathname != "/") uri += "/" + win.location.pathname;          
    }
    var cn = "";
    
    var uriParams = self.$store.getters["getUriParams"];
    uriParams['cn'] && (cn = uriParams['cn']);
    var country = self.$store.getters["country"];
    // paramStr1 , paramInt1
    var allParams = {
        clientId:getFingerId(),
        userId:0,
        userName:"",
        country:country,
        channel:cn,
        category:"",
        act:"",
        val:0,
        step:0,
        fromType:"h5",
        uri:uri,
        status:0,
        error_code:"",
        error_info:"",
        ua:ua,
        cts:(new Date()).getTime(),
        isClient:1,
        platform:self.$store.getters['getPlatfrom']
    };
    // 合并参数
    for (var key in params) {
        if (key.indexOf("paramStr") != -1 || key == "error_code") {
            allParams[key] = params[key] + "";
        } else {
            allParams[key] = params[key];
        }
    }
    var user = self.$store.state.user;
    if (user.userId) {
        allParams.userId = user.userId;
        allParams.userName = user.username;  
    }
    reportEventAction(allParams);
}

//读取cookies
export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) return unescape(arr[2]);
    else return null;
}

//删除cookies
export function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}


// WEBPACK FOOTER //
// ./src/utils/hook.js